
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M7.72 15.868c.065.083.17.132.28.132.11 0 .215-.049.28-.132.235-.292 5.72-7.18 5.72-10.201C14 2.542 11.308 0 8 0S2 2.542 2 5.667c0 3.022 5.485 9.909 5.72 10.201zM5.6 5.5C5.6 6.878 6.722 8 8.1 8s2.5-1.122 2.5-2.5S9.478 3 8.1 3a2.503 2.503 0 00-2.5 2.5z"}})])
          )
        }
      }
    